// cohorts/list hooks
// TanStack Query and client-state hooks only. Pure API functions belong in services/.
import { useQuery } from "@tanstack/react-query";
import { STALE_TIME } from "@core/libs/react-query";
import { cohortKeys } from "@modules/cohorts/_shared";
import { listCohorts } from "../services";

/**
 * The cohort list. `operational` tier: another account can create or reassign a cohort while the
 * page is open, and access is never cached for long.
 */
export function useCohorts() {
  return useQuery({
    queryKey: cohortKeys.list(),
    queryFn: listCohorts,
    staleTime: STALE_TIME.operational,
  });
}
